import { TableBody, TableCell, TableHead, Pagination, TableRow, Stack, Typography, Box, Button, Modal, Card, CardContent, IconButton } from '@mui/material';
import React, { useState, useEffect } from 'react';
import SearchTxtField from '../../../components/SearchTxtField';
import StyledTableContainer from '../../../components/StyledTableContainer';
import route from '../../../utils/Routes';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import CustomDropDown from '../../../components/CustomDropDown';
import { convert10, formatDateWithJs, formatDoPymtStatus, formatPoProdStatus, getSrchTypeTxt, isNotEmpty, NumberFormatter } from '../../../utils/format';
import settingsSvg from '../../../assets/svg/settingsBtn.svg';
import { styled } from "@mui/material/styles";
import { Add, Settings } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import ScrollBox from '../../../components/ScrollBox';
import { List, ListItem, Checkbox } from "@mui/material";
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getPotListServ, getSingleComServ } from '../../../services/com-service';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Edit } from '@mui/icons-material';
import ClientRemark from './ClientRemark';
import constants from '../../../utils/Constants';
import { poTrackingExcelServ } from '../../../services/excel-service';

const ImageButton = styled(Button)({
    padding: 0, // Remove default padding
    minWidth: 0, // Remove default minWidth
    borderRadius: "8px", // Add border radius if needed
    overflow: "hidden",
    "& img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
});


const doColumns = [
    { id: 'doIdStrg', label: "DO NUMBER", align: 'center', minWidth: 50, },
    { id: 'doLineNo', label: "DOL", align: 'center', minWidth: 30 },
    { id: 'deliveredQty', label: "QTY", align: 'center', minWidth: 30 },
    { id: 'deliveredAt', label: "DELIVERED ON", align: 'center', minWidth: 30 },
    { id: 'invNo', label: "INVOICE NO", align: 'center', minWidth: 30 },
    { id: 'invDate', label: "INVOICE DATE", align: 'center', minWidth: 30 },
    { id: 'pymtStatus', label: "PAYMENT STATUS", align: 'center', minWidth: 30 },
]

const ddArr = [
    { value: "poIdStrg", label: "PO NUMBER" },
    { value: "comProdIdStrg", label: "Material Code" },
    { value: "prodName", label: "Description" },
    { value: "mfrName", label: "Original MNFR" }
]

export default function PoTrackingList() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setLoadingScreen, ctxtUser, selCom, setSelComValue } = useAuthContext();

    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const queryComId = searchParams.get("comId");
    const searchType = searchParams.get("st") || ddArr[0].value;
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");

    const tokenComId = ctxtUser?.comId;
    const comId = ctxtUser?.isComUser ? tokenComId : queryComId;
    // const { pgNo } = location.state || {};

    const columns = [
        { id: 'poIdStrg', label: "PO NUMBER", align: 'center', minWidth: 150, },
        { id: 'lineNo', label: "POL", align: 'center', minWidth: 150 },
        { id: 'comProdIdStrg', label: "MATERIAL CODE", align: 'center', minWidth: 150 },
        { id: 'mfrName', label: "ORIGINAL MNFR", align: 'left', minWidth: 150 },
        { id: 'prodName', label: "DESCRIPTION", align: 'left', minWidth: 150 },
        { id: 'prodStatus', label: "STATUS", align: 'left', minWidth: 120 },
        { id: 'orderedQty', label: "PO QTY", align: 'center', minWidth: 120 },
        { id: 'deliveredQty', label: "DELIVERED QTY", align: 'center', minWidth: 120 },
        { id: 'balQty', label: "REMAINING QTY", align: 'center', minWidth: 120 },
        { id: 'do', label: "No of DO", align: 'center', minWidth: 100 },
        { id: 'estTimeArr', label: "ETA", align: 'center', minWidth: 120 },
        { id: 'expecDelDate', label: "ETD", align: 'center', minWidth: 120 },
        { id: 'delLocation', label: "DELIVERY LOCATION", align: 'left', minWidth: 120 },
        { id: 'isPaid', label: "PAYMENT STATUS", align: 'center', minWidth: 120 },
        { id: 'amtcRemarks', label: "AMTC REMARKS", align: 'left', minWidth: 120 },
        { id: 'clientRemarks', label: "CLIENT REMARKS", align: 'left', minWidth: 120 },
        ...(ctxtUser?.isComUser === true ? [{ id: 'editRemark', label: "EDIT REMARK", align: 'center', minWidth: 10 }] :
            ctxtUser?.userType === constants.accounts ? [{ id: 'editInv', label: "EDIT INVOICE", align: 'center', minWidth: 10 }] :
                [{ id: 'edit', label: "EDIT", align: 'center', minWidth: 10 }]),
    ];


    // const [searchType, setSearchType] = useState(ddArr[0].value);
    // const [searchKeyType, setSearchKeyType] = useState(ddArr[0].value);
    // const [searchKeyWord, setSearchKeyWord] = useState("");
    //  const [pageNumber, setPageNumber] = useState(pgNo ? parseInt(pgNo) : 1);
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const limit = 7;
    const theme = useTheme();

    const { isLoading, isError, error, data: potDataArr } = useQuery([QueryKey.poTrackingList, pgNo, isSrchBtnClick, comId],
        () => getPotListServ({ comId, limit, pageNumber: pgNo, searchKeyWord: searchWord, searchKeyType: searchType }), {
        enabled: isNotEmpty(comId),
        keepPreviousData: true
    });

    const [colMdlOpen, setColMdlOpen] = useState(false);
    const [checkedItems, setCheckedItems] = useState([...columns]);
    const [visibleColumns, setVisibleColumns] = useState([...columns]);
    const [selectAll, setSelectAll] = useState(true);   // Track if all items are selected
    const [expandedRows, setExpandedRows] = useState([]);

    const { isLoading: isComLoading, isError: isComErr, error: comErr, data: comData } = useQuery([QueryKey.singleCom, comId],
        () => getSingleComServ(comId), {
        enabled: isNotEmpty(comId),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    const [currPoProd, setCurrPoProd] = useState({});
    const [crmMdl, setCrmMdl] = useState(false);
    const handleCrmMdlClose = () => setCrmMdl(false);
    const handleCrmMdlOpen = (poProdData) => {
        setCurrPoProd(poProdData);
        setCrmMdl(true);
    }



    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        setLoadingScreen(isComLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComLoading]);

    useEffect(() => {
        if (!comId) {
            navigate(-1);
        }
    }, [comId, navigate]);

    useEffect(() => {
        if (!comData) {
            return;
        } else {
            setSelComValue({ comId: comData?.id, comName: comData?.comName, comLogo: comData?.logo, potProjDet: comData?.potProjDet })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comData])



    const handleColMdlOpen = () => setColMdlOpen(true);
    const handleColMdlClose = () => setColMdlOpen(false);


    const handleToggle = (column) => {
        const currentIndex = checkedItems.findIndex((item) => item.id === column.id);
        const newChecked = [...checkedItems];
        if (currentIndex === -1) {
            newChecked.push(column);// Add the column object if not already in the array
        } else {
            newChecked.splice(currentIndex, 1); // Remove the column object if it's already in the array
        }
        setCheckedItems(newChecked);
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setCheckedItems([]);// Deselect all items
        } else {
            setCheckedItems(columns);  // Select all items
        }
        setSelectAll(!selectAll); // Toggle the state
    };

    const handleExpandRow = (rowId) => {
        setExpandedRows((prevExpandedRows) => {
            if (prevExpandedRows.includes(rowId)) {
                return prevExpandedRows.filter((id) => id !== rowId);
            } else {
                return [...prevExpandedRows, rowId];
            }
        });
    };

    async function onSearchBtnClick(e) {
        // setSearchKeyWord(searchWord);
        // setSearchKeyType(searchType);
        setIsSrchBtnClick((prevVal) => ++prevVal)
        // setPageNumber(1);
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
        setExpandedRows([]);
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleDDChange(e) {
        setSearchParams(prev => {
            prev.set("st", e.target.value)
            return prev
        }, { replace: true })
    }

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    function handleMdlSave() {
        setVisibleColumns(checkedItems);
        handleColMdlClose();
        setExpandedRows([]);
    }

    const handleEditClick = (poId) => {
        navigate(route.editPot, {
            state: {
                comId, comName: selCom?.comName, comLogo: selCom?.comLogo,
                potProjDet: selCom?.potProjDet, poId, pgNo, s: querySearchWord, st: searchType
            }
        })
    };
    function handleAddPotClick() {
        navigate(route.addPot, {
            state: {
                comId, comName: selCom?.comName, comLogo: selCom?.comLogo,
                potProjDet: selCom?.potProjDet, pgNo, s: querySearchWord, st: searchType
            }
        })
    }

    const handleEditInvClick = (poProdId) => {
        navigate(route.accEditPotInvPage, {
            state: {
                comId, comName: selCom?.comName, comLogo: selCom?.comLogo,
                potProjDet: selCom?.potProjDet, poProdId, pgNo, s: querySearchWord, st: searchType
            }
        })
    };

    async function downloadExcel() {
        setLoadingScreen(true);
        try {
            let filterObj = {
                ...(comId && { comId }),
                ...(searchWord && { searchWord }),
                ...(searchType && { searchType }),
                ...(limit && { limit }),
                ...(pgNo && { offset: (pgNo * limit) - limit }),
            }

            const url = await poTrackingExcelServ({ filterObj, columns: visibleColumns, doColumns });
            // Create and trigger download
            const a = document.createElement('a');
            a.href = url;
            const now = new Date();
            const fileName = `tracking_record_${now.toISOString().replace(/[-T:.Z]/g, '')}.xlsx`;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.log(err);
            customAlert(err)
        }
        setLoadingScreen(false);
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    if (isComErr) {
        customAlert(comErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <Stack height={"100%"} width={"100%"}>
            <Stack direction={"row"} sx={{ width: '100%', pr: 2, mb: 2, mt: 1, alignItems: 'center', justifyContent: 'space-between' }} >
                <Stack width={"30%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500 }}>PO Tracking List</Typography>
                </Stack>


                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={1} width={"40%"}>
                    <Box mb={0.5}><SearchTxtField variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch}
                        onBtnClick={onSearchBtnClick} placeholder={`Search By ${getSrchTypeTxt(ddArr, searchType)} .....`} /></Box>
                    <CustomDropDown height={30} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={ddArr[0].value} />
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"30%"}>
                    {ctxtUser?.userType === constants.admin && <Button variant='outlined' startIcon={<Add />} onClick={handleAddPotClick} sx={{
                        color: theme.palette.custom.btn, borderColor: theme.palette.custom.btn, height: 30
                    }}>
                        Add PO</Button>}
                    {/* <ImageButton>
                        <img src={settingsSvg} alt="Example Button" style={{ height: 35 }} onClick={handleColMdlOpen} />
                    </ImageButton> */}
                    <Button onClick={downloadExcel}
                        sx={{ backgroundColor: theme.palette.custom.btn, color: "white", height: 30, width: 100 }}
                        variant="contained"  >Export</Button>
                    <IconButton onClick={handleColMdlOpen}>
                        <Settings sx={{ color: theme.palette.custom.btn }} />
                    </IconButton>

                </Stack>
            </Stack>
            {/* <Stack sx={{width:{ lg:"100%" ,md:"80%"}}}> */}

            {visibleColumns && <StyledTableContainer height={"100%"} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {visibleColumns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(potDataArr?.arr || []).map((row) => {
                        return (
                            <React.Fragment key={row.id}>
                                <TableRow hover tabIndex={-1}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 }, height: 50,
                                        backgroundColor: expandedRows.includes(row.id) ? "rgba(162, 214, 249, 0.4)" : 'transparent',
                                    }} >

                                    {visibleColumns.map((column) => {
                                        const value = row[column.id];
                                        switch (column.id) {
                                            case "edit":
                                                return <TableCell align="center" key={column.id}>
                                                    <IconButton onClick={() => handleEditClick(row["poId"])} color="primary">
                                                        <Edit sx={{ color: theme.palette.custom.btn }} />
                                                    </IconButton>
                                                </TableCell>
                                            case "editRemark":
                                                return <TableCell align="center" key={column.id}>
                                                    <IconButton onClick={() => handleCrmMdlOpen(row)} color="primary">
                                                        <Edit sx={{ color: theme.palette.custom.btn }} />
                                                    </IconButton>
                                                </TableCell>
                                            case "editInv":
                                                return <TableCell align="center" key={column.id}>
                                                    <IconButton onClick={() => handleEditInvClick(row?.id)} color="primary">
                                                        <Edit sx={{ color: theme.palette.custom.btn }} />
                                                    </IconButton>
                                                </TableCell>
                                            case "prodStatus":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {(value === null || value === "" || value === "null") ? "NA" : formatPoProdStatus(value)}
                                                </TableCell>
                                            case "orderedQty":
                                            case "deliveredQty":
                                            case "balQty":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {NumberFormatter(value)}
                                                </TableCell>
                                            case "estTimeArr":
                                            case "expecDelDate":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatDateWithJs(value)}
                                                </TableCell>
                                            case "isPaid":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {(value === null || value === "" || value === "null") ? "NA" : convert10(value)}
                                                </TableCell>
                                            case "do":
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        <Stack direction="row" alignItems="center" gap={1}
                                                            onClick={() => handleExpandRow(row.id)} sx={{ cursor: 'pointer' }}>
                                                            {expandedRows.includes(row.id) ? <ExpandLess color='error' /> : <ExpandMore sx={{ color: theme.palette.custom.btn }} />}
                                                            <span>{row?.doArr?.length ?? 0}</span>
                                                        </Stack>
                                                    </TableCell>
                                                )
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "NA" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                                {expandedRows.includes(row.id) && (
                                    <TableRow>
                                        <TableCell colSpan={visibleColumns.length} sx={{ padding: 0 }}>
                                            <Box sx={{
                                                pb: 2, pl: 5, pt: 1,
                                                maxHeight: expandedRows.includes(row.id) ? 300 : '0', // Max height for smooth transition
                                                opacity: expandedRows.includes(row.id) ? 1 : 0, // Fade-in/out effect
                                                transform: expandedRows.includes(row.id) ? 'scaleY(1)' : 'scaleY(0.9)', // Scale effect
                                                overflow: 'hidden',
                                                transition: 'max-height 1s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.5s ease-in-out, transform 0.5s ease-in-out', // Apply smooth transition
                                                backgroundColor: expandedRows.includes(row.id) ? '#f0f4f8' : 'transparent', // Background color for expanded row
                                            }}>
                                                <Stack>
                                                    <Typography variant="h6" mb={1}>List of DOs:</Typography>
                                                    <Stack direction={"row"} pl={10}>
                                                        <StyledTableContainer width={"50%"} height={180} isStickyHeader={true}>
                                                            <TableHead sx={{ backgroundColor: "rgba(253, 240, 213, 0.4)" }}>
                                                                <TableRow>
                                                                    {doColumns.map((doColumn, index) => (
                                                                        <TableCell align={doColumn.align} style={{ minWidth: doColumn.minWidth }} key={`doColumn-${doColumn.id}-${index}`}
                                                                            sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                                                            {doColumn.label}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(row?.doArr ?? []).map((doItem) => (
                                                                    <TableRow key={`doItem-${doItem.id}-`} sx={{
                                                                        height: 37, '&:last-child td, &:last-child th': { border: 0 },
                                                                    }}>
                                                                        {doColumns.map((doColumn) => {
                                                                            const doVal = doItem[doColumn.id];
                                                                            switch (doColumn.id) {
                                                                                case "doLineNo":
                                                                                case "deliveredQty":
                                                                                    return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                        {NumberFormatter(doVal)}
                                                                                    </TableCell>
                                                                                case "deliveredAt":
                                                                                case "invDate":
                                                                                    return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                        {formatDateWithJs(doVal)}
                                                                                    </TableCell>
                                                                                case "pymtStatus":
                                                                                    return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                        {formatDoPymtStatus(doVal)}
                                                                                    </TableCell>
                                                                                default:
                                                                                    return (
                                                                                        <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                            {(doVal === null || doVal === "" || doVal === "null") ? "NA" : doVal}
                                                                                        </TableCell>
                                                                                    );
                                                                            }
                                                                        })}
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </StyledTableContainer>
                                                    </Stack>
                                                </Stack>

                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        );
                    })}
                </TableBody>

            </StyledTableContainer>}
            {/* </Stack> */}
            <Stack sx={{ alignItems: "center", mt: 1 }}>
                <Pagination count={Math.ceil(potDataArr?.totalCount / limit) || 0} color={"primary"} page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
            </Stack>

            <Modal open={colMdlOpen} onClose={handleColMdlClose}>
                <Box sx={modalStyle} >
                    <Stack width={"100%"} justifyContent={"center"} alignItems={"center"}>
                        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Select Columns</Typography>
                    </Stack>
                    <ScrollBox height={"90%"}>
                        <List >
                            {columns.map((column) => (
                                <ListItem key={column.id} disablePadding style={{ marginBottom: "8px", }} >
                                    <Card
                                        onClick={() => handleToggle(column)} // Toggle on card click
                                        style={{
                                            width: "100%", display: "flex", alignItems: "center", padding: "8px",
                                            backgroundColor: checkedItems.some((item) => item.id === column.id)
                                                ? "#e3f2fd" : "#f5f5f5",
                                            cursor: "pointer",
                                        }}>
                                        <Checkbox
                                            checked={checkedItems.some((item) => item.id === column.id)}
                                            onChange={() => handleToggle(column)}
                                            onClick={(e) => e.stopPropagation()} // Prevent card click from toggling twice
                                        />
                                        <CardContent style={{ padding: 0, paddingLeft: "8px" }}>
                                            <Typography variant="body1">{column.label}</Typography>
                                        </CardContent>
                                    </Card>
                                </ListItem>
                            ))}
                        </List>
                    </ScrollBox>
                    <Stack direction={"row"} width={"100%"} justifyContent={"center"} alignItems={"center"} gap={2}>
                        <Button variant='contained' onClick={handleSelectAll}
                            sx={{ color: "white", backgroundColor: theme.palette.custom.sub, height: 30, width: 150 }}>
                            {selectAll ? "Deselect All" : "Select All"}
                        </Button>
                        <Button variant='contained' onClick={handleMdlSave}
                            sx={{ color: "white", backgroundColor: theme.palette.custom.btn, height: 30, width: 150 }}>
                            Save</Button>
                    </Stack>
                </Box>
            </Modal>
            {potDataArr && <ClientRemark modalOpen={crmMdl} handleModalClose={handleCrmMdlClose} poProdData={currPoProd} />}

        </Stack>
    );
}


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470, height: "90%",
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2
};

